export default __webpack_public_path__ + "assets/1507bedcff606bcfe4f90d469e4b0bce.png";